export const HandoutsType = {
  IGetHandoutsSeenOrNotService: Symbol("IGetHandoutsSeenOrNotService"),
  IRemoveHandoutService: Symbol("IRemoveHandoutService"),
  ICreateHandoutService: Symbol("ICreateHandoutService"),
  ICreateHandoutAckService: Symbol("ICreateHandoutAckService"),
};
